import { defaultColumns, defaultSort } from '../../components/data/services/services/columns';

export default {
  state: {
    services: [],
    rawServices: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    services: state => state.services,
    rawServices: state => state.rawServices,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setServices(state, services) {
      state.services = services;
    },
    setRawServices(state, services) {
      state.rawServices = services;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/service-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'service-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'service-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const services = await axios.get('api/services-pagination' + (query || ''));
        commit('setServices', services);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchAllRaw({ commit }) {
      const services = await axios.get('api/services');
      commit('setRawServices', services);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/services/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/services', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/services', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/services/${id}`);
    },
  },
};
